/* RD - Responsable de Diseño -  toma decisión de la(s) propuesta(s) asignadas a su rol */

//*react- recursos
  import { useState, useEffect} from "react";
  import { Panel, PanelGroup } from "rsuite";
  import ReactPaginate from "react-paginate";

//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";
  import { SlidingPanel } from "@reactjscomponentrepository/frontend-components/lib/components";

//*clases 
  import { Col, Row } from "react-bootstrap";
  //import ReactTooltip from "react-tooltip";
  import '../../../../css/mdi.css'; 

//*imágenes
  import { BsEnvelope, BsCalendarEvent } from "react-icons/bs";
  import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";

//*archivo & componentes (otros componentes enlazados)
  import RDDocumentar from "./RD.Documentar"; 

//*api's (servicios y store)
  
  import analysisServicio from "../../../../api/recursos/analysis/analysis.servicio"; 
  import analysisStore from "../../../../api/recursos/analysis/analysis.store"; 

  import catalogsServicio from "../../../../api/recursos/catalogs/catalogs.servicio"; 
  import catalogsStore from "../../../../api/recursos/catalogs/catalogs.store"; 

  import ptCatalogsServicio from "../../../../api/recursos/ptCatalogs/ptCatalogs.servicio"; 
  import ptCatalogsStore from "../../../../api/recursos/ptCatalogs/ptCatalogs.store"; 

//*store's

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json"

//*interface  
  interface propsRD {
    tokenStore: any;
    menuStore: any;
    quitaErrorPagina:any;
    recargaPaginaSSC:any;
    recargaPaginaSSC_Not:any;
  }  

//*componente
  export default function RD(props: propsRD){

  //*api store
    const { guardaGetAllDecisionStore, catDecisionesStore,
            guardaGetAllProofStore, catPruebasStore,
            generaObjErrorCatalogsStore } =  
        catalogsStore((state:any) =>( { 
            guardaGetAllDecisionStore: state.guardaGetAllDecisionStore,
            catDecisionesStore: state.catDecisionesStore,
            guardaGetAllProofStore: state.guardaGetAllProofStore,
            catPruebasStore: state.catPruebasStore,
            generaObjErrorCatalogsStore: state.generaObjErrorCatalogsStore
    }));

    const { guardaPTGetAllFeaturesStore, catPTCaracteristicasStore,
            generaObjErrorPtCatalogsStore } =  
        ptCatalogsStore((state:any) =>( { 
            guardaPTGetAllFeaturesStore: state.guardaPTGetAllFeaturesStore,
            catPTCaracteristicasStore: state.catPTCaracteristicasStore,
            generaObjErrorPtCatalogsStore: state.generaObjErrorPtCatalogsStore
    }));
      
    const { guardaGetSummarybyUserStore, pfcStore, 
            generaObjErrorAnalysisStore } =  
        analysisStore((state:any) =>( { 
            guardaGetSummarybyUserStore: state.guardaGetSummarybyUserStore,
            pfcStore: state.pfcStore, 
            generaObjErrorAnalysisStore: state.generaObjErrorAnalysisStore
    }));

  //*store's

  //*datos
    var _ = require('underscore');

  //*constantes y variables
    let eti = etiquetasSSC.RD;
    let x0, x1, x1a, x2, x3 = '';
    //paginación: constante para el manejo de la 
      const data  = pfcStore;  //data es quien se muestra para que generé la paginación
      const [currentItems, setCurrentItems] = useState([]);  //elementos mostrados según páginación
      const [pageCount, setPageCount] = useState(0);  //contabilidad de la página
      const [itemOffset, setItemOffset] = useState(0);  //desplazamiento 
      const itemsPerPage = 10;   //número de elementos a mostrar

  //*useState
    const [swRecarga, setSwRecarga] =  useState(false);
    const [swRecargaRD, setSwRecargaRD] = useState(false); //usado para remasterizar esta página
    const [cargandoSpin,setCargandoSpin] = useState(false);

    const [pfcId, setpfcId] = useState(0);
   
    const [swPFC, setSwPFC] = useState(false);
    const [abreSP, setAbreSP] = useState(false);
   
    const [totalEvidencias, setTotalEvidencias] = useState(0);   
    const [totalDecision, setTotalDecision] = useState(0);   
    
  //*useEffect
    useEffect(()=> { // al montar
      console.log('RD - monto')
      props.quitaErrorPagina();
      console.clear();
    },[]);
    
    useEffect(()=> { //Carga cátalogo "Pruebas"- llama API - Catalogs/GetAllProof
      setCargandoSpin(true); 
      catalogsServicio.cargaGetAllProof(props.tokenStore)
        .then((response:any) => {
          if (response.status==200){  //revisa si hay error
              guardaGetAllProofStore(response.data).then( function(data:any) { 
                //console.log('Cargo información de api en CatPruebasStore', data);
              })
          }
          setCargandoSpin(false);   
        })
        .catch((ex) => { 
            console.log ("--catch - ex (GetAllProof): ", ex);
            generaObjErrorCatalogsStore(ex.response, true, '', '', 'RD-Catalogs/GetAllProof', 'RD');
            setCargandoSpin(false);   
            recargaPaginaSSC();
        })
    },[]);
    
    useEffect(()=> { //Carga cátalogo "Decisiones"- llama API - Catalogs/GetAllDecision
      setCargandoSpin(true); 
      catalogsServicio.cargaGetAllDecision(props.tokenStore)
        .then((response:any) => {
          if (response.status==200){  //revisa si hay error
              guardaGetAllDecisionStore(response.data).then( function(data:any) { 
                //console.log('Cargo información de api en CatDecionesStore', data);
              })
          }
          setCargandoSpin(false);   
        })
        .catch((ex) => { 
            console.log ("--catch - ex (GetAllDecision): ", ex);
            generaObjErrorCatalogsStore(ex.response, true, '', '', 'RD-Catalogs/GetAllDecision','RD');
            setCargandoSpin(false);  
            recargaPaginaSSC(); 
        })
    },[]);

    useEffect(()=> { //Carga cátalogo "Caracteristicas"- llama API - ptCatalogs/GetAllDecision
      setCargandoSpin(true); 
      ptCatalogsServicio.cargaGetAllFeatures(props.tokenStore)
        .then((response:any) => {
          if (response.status==200){  //revisa si hay error
              guardaPTGetAllFeaturesStore(response.data).then( function(data:any) { 
                //console.log('Cargo información de api en CatEvidenciasStore , data );
              })
          }
          setCargandoSpin(false);   
        })
        .catch((ex) => { 
            console.log ("--catch - ex (GetAllProof): ", ex);
            generaObjErrorPtCatalogsStore(ex.response, true, '', '', 'RD-PTCatalogs/GetAllFeatures','RD');
            setCargandoSpin(false);   
            recargaPaginaSSC();
        })
    },[]);

    useEffect(()=> { //Carga lista pfc - llama API - Analysis/GetSummarybyUser/es
      //console.log("...useEffect - carga propuestas con lectura de api Analysis/GetSummarybyUser/es");
      setCargandoSpin(true);
      analysisServicio.cargaGetSummarybyUser(props.tokenStore)
        .then(function(response:any){
            if (response.status==200){  //revisa si hay error
                guardaGetSummarybyUserStore(response.data).then( function(datos:any) { 
                  //console.log('Cargo información de api en pfcStore (lista pfc)', datos );
                  const  data  = datos; // para paginación
                })
            }
            setCargandoSpin(false);
        })
        .catch((ex) => {
            console.log ("--catch - ex (cargaGetSummarybyUser): ", ex.response.status);
            if (ex.response.status==404) //no es error solo no tiene información
                console.log('nota: no es error solo no tiene información')
            else{
                generaObjErrorAnalysisStore(ex.response, true, '', '', 'RD Analysis/GetSummarybyUser','RD')
                recargaPaginaSSC();
            }    
            setCargandoSpin(false);
        })
    },[]);
    
    useEffect(()=> { // uso este puente para recargar elementos del front, no uso ese useState
      console.log('RD - rederizando............');
      setSwPFC(!swPFC);
      setSwRecargaRD(swRecargaRD);
    },[swRecarga]);

     //páginación: se ejectura al cambio de un elementos (al click en los botones)
        useEffect(() => { 
          console.log('entro a useEffect paginación')
          const endOffset = itemOffset + itemsPerPage;
          setCurrentItems(data.slice(itemOffset, endOffset));
          setPageCount(Math.ceil(data.length / itemsPerPage));
          setSwRecarga(!swRecarga);
          console.log('::data', data);
        }, [itemOffset, itemsPerPage, data]);
      
        useEffect(()=>{ window.scrollTo({top:0});  },[currentItems]); //para páginación

  //*funciones

    const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC

    const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

    const recargaRD = () => {  // con esto ejecuto un useEffect, lo uso para renderizar el front 
      setCurrentItems(pfcStore);
      setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
    }  

    const abreSlidingPanelconDetalles = (pfc:any) => {  // se genera al dar click en documentar - abre ventana con los detalles pfc 
      setpfcId(pfc.id);
      setAbreSP(!abreSP); //al abrir la ventana SlidingPanel abre ->RD.documentar, la lectura del api (detalles) esta en un useEffect
      setSwRecarga(!swRecarga)
    }

    const botonCierraSlidingPanel = () => { setAbreSP(false) }

    const clickPaginacion = (event: any) => {  //paginación: se ejecuta cuando se da un click en los elementos de páginación (botones)
      const newOffset = (event.selected * itemsPerPage) % data.length;
      //console.log("newOffset--------", newOffset);
      setItemOffset(newOffset);
      setSwRecarga(!swRecarga) 
    };
   
   

  //*vista
    return(
    <>
      <div>

        {/* nota de mensaje de error */}
         { (props.menuStore[2].errorPagina==true) &&
              (<> <label className='color-red'>Nota: se detecto un error al leer un recurso API, ¡algunos componentes pueden no funcionar correctamente!</label><br/><br/> </>)
         }

        {/* Proceso/Frecuencia/Ciclo */}
          <div> <h5>Proceso/Frecuencia/Ciclo</h5></div>
        
        {/* pfc existentes */}        
          <div>
            {/*  currentItems trae pxfStore se usa ésta para la paginación */ }
            { currentItems?.map((pfc:any, index:any) => (
              (x0 =  `<span id='pn'>${pfc.processname}</span>&nbsp;
                      <span class="claseEstatus claseEstatusAct">${pfc.estatusProceso} </span>&nbsp;&nbsp;`),
              (x1 =  `<span id="estatushV"> ${pfc.estatusTexto}</span>`),
              (x1a = `<span id="estatushN"> ${pfc.estatusTexto}</span>`),

              /*x2 forma el contendio del header del panel*/
              (x2 = (
                <>
                  <div id={`divpanel_${pfc.id}`}>
                    <Row>
                      <Col sm={9}>
                        {/* acrónimo/frecuencia/ciclo & total de propuestas */}
                          <span id="panelDes">
                              <span className='h3 color-secundario'> {pfc.pfcNombre} </span>
                              <span className="circulo pt-1 h5">  {pfc.totalPropuestas}</span>&nbsp;
                              <span className="circuloText h5"> {eti.etiquetas[1].text}</span>
                              <br />
                              {/* proceso & estatus de programa */}
                              <span className='h6'>{pfc.processname} </span> &nbsp;
                              <span className={pfc.clasexEstatusIcono}>{pfc.estatusProceso}</span>&nbsp;&nbsp;
                          </span>
                      
                        {/* estatus de envio */}
                          <span>
                            {pfc.estatusTexto === "Enviada" 
                              ?(<>
                                  <BsEnvelope size="14px" color="#28A745" />
                                  <span dangerouslySetInnerHTML={{ __html: x1 }} ></span>
                                </>) 
                              :(<>
                                  <BsEnvelope size="14px" color="#fd7e14" />
                                  <span dangerouslySetInnerHTML={{ __html: x1a }} ></span>
                                </>)
                            }
                          </span>
                      </Col>

                      {/* botón Documentar */}
                      <Col sm={3} className="text-right padding-right-2r">
                        <button id="btnDec_{pdxId}_{pfc.id}" type="button" className="btn rounded-pill noBR min-width-130 background-color-Orange font-size-12">
                          <i className="mdi mdi-cursor-default-click"></i>&nbsp;Documentar
                        </button>
                      </Col>
                    </Row>
                  </div>
                </>
              )),
              (<>
                { pfc.sent == false &&
                      (<> 
                        <hr />
                        <PanelGroup>  {/* accordion */}
                          <Panel
                            header={x2}
                            /* eventKey={index} usado cuando se quiere un solo panel abierto */
                            key={pfc.key}
                            id={pfc.id}
                            /* collapsible={pfc.abierto} */
                            onClick={() => abreSlidingPanelconDetalles(pfc)}
                          >
                          </Panel>
                        </PanelGroup> 
                  </>)}
              </>)
            ))}
          </div>
        
        <hr/>  

        {/* ventana para pfc detalle */}   
          <SlidingPanel isOpen={abreSP} 
              type='right' 
              size={60}
              title={eti.contenido[0].text} 
              closeClick={()=>botonCierraSlidingPanel()} >
              <RDDocumentar
                  key = {pfcId}
                  tokenStore={props.tokenStore}
                  pfcId = {pfcId}
                  catDecisiones = {catDecisionesStore}
                  catPruebas = {catPruebasStore}
                  catPTCaracteristicas = {catPTCaracteristicasStore}
                  botonCierraSlidingPanel={botonCierraSlidingPanel}
                  recargaRD = {recargaRD}
                  recargaPaginaSSC = {recargaPaginaSSC}
                  recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
              />
          </SlidingPanel>  

        {/* paginación: elemento visuales  */}
          {  pageCount > 1 &&
            (<>
                <ReactPaginate
                  //2.1
                  breakClassName="..."
                  nextLabel={
                  <AiOutlineDoubleRight style={{ fontSize: 18, width: 150, verticalAlign: "middle", marginLeft: "-10px",}} /> }          
                  pageRangeDisplayed={2}
                  pageCount={pageCount}
                  previousLabel={
                    <AiOutlineDoubleLeft style={{ fontSize: 18, width: 150, verticalAlign: "middle",  marginLeft: "10px", }} /> }
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-num"
                  previousLinkClassName="page-num"
                  nextLinkClassName="page-num"
                  activeClassName="active"
                  disabledLinkClassName="gray"
                  onPageChange={clickPaginacion}
                  // onClick={clickPaginacion}
                />
            </>) 
          }
      
        {/* ventana de carga con spin que se abre mientras lee el api */}
          { cargandoSpin && <CargandoSpin /> }
        
      </div> 
    </>
    )
  }
